import { useTranslation } from "react-i18next";
import { Gavel } from "lucide-react";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

/**
 * AuctionFieldsSection — Auction-specific fields (B2B only, sale_type=auction):
 * Starting price, reserve price, min increment, end-time, buy-now price.
 *
 * Receives `form` + `update(k,v)` from the parent. Pure presentational.
 */
export default function AuctionFieldsSection({ form, update, isAuction }) {
    const { t } = useTranslation();
    return (
        <div className="bg-[#111827] text-white rounded-sm p-6 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="auction-fields">
            <h2 className="md:col-span-2 font-display text-lg font-bold flex items-center gap-2">
                <Gavel className="w-5 h-5 text-[#FFCC00]" /> {t("create_listing.auction_details")}
            </h2>
            <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60">
                    {t("create_listing.auction_starting_price")}
                </Label>
                <Input
                    type="number"
                    value={form.starting_price}
                    onChange={(e) => update("starting_price", e.target.value)}
                    required={isAuction}
                    className="mt-1.5 rounded-sm bg-white text-[#111827]"
                    data-testid="form-starting-price"
                />
            </div>
            <div data-testid="reserve-price-wrap">
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60">
                    Mindestpreis (Reserve)
                </Label>
                <Input
                    type="number"
                    value={form.reserve_price}
                    onChange={(e) => update("reserve_price", e.target.value)}
                    placeholder="optional — z. B. 8.500"
                    className="mt-1.5 rounded-sm bg-white text-[#111827]"
                    data-testid="form-reserve-price"
                />
                <div className="text-[10px] text-white/50 mt-1">
                    Wird der Mindestpreis nicht erreicht, ist der Höchstbieter <strong>nicht</strong> verpflichtet zu kaufen und Sie müssen das Fahrzeug <strong>nicht</strong> abgeben.
                </div>
            </div>
            <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60">
                    {t("create_listing.auction_min_increment")}
                </Label>
                <Input
                    type="number"
                    value={form.min_increment}
                    onChange={(e) => update("min_increment", e.target.value)}
                    className="mt-1.5 rounded-sm bg-white text-[#111827]"
                    data-testid="form-min-increment"
                />
            </div>
            <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60">
                    {t("create_listing.auction_end")}
                </Label>
                <Input
                    type="datetime-local"
                    value={form.auction_end}
                    onChange={(e) => update("auction_end", e.target.value)}
                    required={isAuction}
                    className="mt-1.5 rounded-sm bg-white text-[#111827]"
                    data-testid="form-auction-end"
                />
            </div>
            <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60 flex items-center gap-1">
                    {t("create_listing.buy_now_price")}{" "}
                    <span className="text-white/40 normal-case font-normal">
                        {t("create_listing.buy_now_optional")}
                    </span>
                </Label>
                <Input
                    type="number"
                    value={form.buy_now_price}
                    onChange={(e) => update("buy_now_price", e.target.value)}
                    placeholder={t("create_listing.buy_now_placeholder")}
                    className="mt-1.5 rounded-sm bg-white text-[#111827]"
                    data-testid="form-buy-now-price"
                />
            </div>
            <div className="md:col-span-2 text-[11px] text-white/50 flex items-start gap-2">
                <span className="text-[#FFCC00]">★</span>
                <span>{t("create_listing.sniper_protection")}</span>
            </div>
        </div>
    );
}
